import { Link } from "react-router-dom";
import { CSSProperties } from "react";

const headerStyle: CSSProperties = {
  padding: "20px",
  borderBottom: "2px solid #333",
  marginBottom: "20px",
  backgroundColor: "#f5f5f5"
};

const titleStyle: CSSProperties = {
  margin: 0,
  fontSize: "28px",
  color: "#333"
};

const subtitleStyle: CSSProperties = {
  margin: "5px 0 0 0",
  fontSize: "14px",
  color: "#666"
};

export function PublicBaseView(props: { children: any }) {
  const root = process.env.PUBLIC_URL || "";

  return (
    <div className="App">
      <div style={headerStyle}>
        <Link to={`${root}/public`} style={{ textDecoration: "none", color: "inherit" }}>
          <h1 style={titleStyle}>Volim Višnjan</h1>
          <p style={subtitleStyle}>Fotografije iz prošlosti</p>
        </Link>
      </div>
      <div style={{ padding: "0 20px" }}>
        {props.children}
      </div>
    </div>
  );
}
